import { render } from "./InStorageRecordOriginalDetail.vue?vue&type=template&id=2c5714d3&scoped=true"
import script from "./InStorageRecordOriginalDetail.vue?vue&type=script&lang=js"
export * from "./InStorageRecordOriginalDetail.vue?vue&type=script&lang=js"

import "./InStorageRecordOriginalDetail.vue?vue&type=style&index=0&id=2c5714d3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5714d3"]])

export default __exports__